const staticErrorMessages = {
  NotFound: 'Пользователь не найден',
  SameName: 'Имя уже используется',
  SameEmail: 'Email уже зарегистрирован',
  SameLogin: 'Логин уже используется',
  WrongFormat: 'Неверный формат данных',
  SendEmailError: 'Ошибка при отправке email',
  SamePersonnelNumber: 'Карточка с таким табельным номером уже существует',
  UsersLimitExceeded: 'Пользователей больше создать нельзя',
  UserLimitExceeded: 'Пользователей больше создать нельзя',
  LicenseUsersLimitExceeded: 'Пользователей больше создать нельзя',
  Unknown: 'Неизвестная ошибка'
} as const;

type StaticErrorKey = keyof typeof staticErrorMessages;

export class IdentityErrorService {
  static getErrorMessage(errorCode: string): string {
    if (errorCode in staticErrorMessages) {
      return staticErrorMessages[errorCode as StaticErrorKey];
    }

    const lower = (errorCode ?? '').toLowerCase();
    if (lower.includes('user') && lower.includes('limit')) {
      return 'Пользователей больше создать нельзя';
    }

    if (errorCode.endsWith(`can't be null or empty`)) {
      const field = errorCode.replace(` can't be null or empty`, '');
      return `${field} не может быть пустым`;
    }

    if (errorCode.endsWith('value is incorrect')) {
      const field = errorCode.replace(' value is incorrect', '');
      return `Некорректное значение: ${field}`;
    }

    return staticErrorMessages.Unknown;
  }
}
